// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__1gAP2","rootSmall":"AddTileButton_rootSmall__2Y0SU"};